import { EThemesOG } from '@/constants/themeConfig';

import * as betgalaxy from './Specials.styles.betgalaxy';
import * as betprofessor from './Specials.styles.betprofessor';
import * as betroyale from './Specials.styles.betroyale';
import * as fiestabet from './Specials.styles.fiestabet';
import * as puntgenie from './Specials.styles.puntgenie';
import * as questbet from './Specials.styles.questbet';
import * as wellbet from './Specials.styles.wellbet';
import * as buffalobet from './Specials.styles.buffalobet';
import * as oldgill from './Specials.styles.oldgill';
import * as titanbet from './Specials.styles.titanbet';
import * as slambet from './Specials.styles.slambet';
import * as sugarcastle from './Specials.styles.sugarcastle';
import * as betstride from './Specials.styles.betstride';
import * as goldenbet888 from './Specials.styles.goldenbet888';
import * as chromabet from './Specials.styles.chromabet';
import * as bet575 from './Specials.styles.bet575';
import * as epicodds from './Specials.styles.epicodds';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntgenie,
  questbet,
  wellbet,
  buffalobet,
  oldgill,
  titanbet,
  slambet,
  sugarcastle,
  betstride,
  goldenbet888,
  chromabet,
  bet575,
  epicodds,
};
